import { Flag } from "@kanda-libs/ks-frontend-services";
import { useSelector } from "react-redux";
import monitorSelectors from "store/selectors/monitor";

export interface CompanyRiskFlagHook {
  level?: Flag["level"];
}

export default function useCompanyRiskFlag(id?: string): CompanyRiskFlagHook {
  const monitors = useSelector(monitorSelectors.getEntities);
  const monitor = monitors[id || ""];

  return {
    level: monitor?.flag?.level || "green",
  };
}
